import { useState } from "react";

export default function useFormFields(initialState) {
  const [fields, setValues] = useState(initialState);
  return [
    fields,
    event => {
      setValues({
        ...fields,
        [event.target.id || event.target.name]:
          // eslint-disable-next-line no-nested-ternary
          event.target?.type === "checkbox"
            ? event.target.checked
            : event.target.value
      });
    },
    () => setValues(initialState)
  ];
}
